import * as actions from './entity-list-actions';
import {entityListReducer as reducer} from './entity-list-reducer';
import * as selectors from './entity-list-selectors';

export const EntityList = {reducer, ...actions, ...selectors} as const;
export type {EntityListState} from './entity-list-reducer';
